import {Breakpoints, styled} from '@vw-marketing/us-components';

export const StyledLandingCarDetails = styled.div`
  margin-left: ${(props) => props.theme.size.grid001};
  margin-right: ${(props) => props.theme.size.grid001};
  position: relative;
  z-index: 0;
  height: max-content;

  @media (min-width: ${Breakpoints.b1280}px) {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-start;

    margin-left: ${(props) => props.theme.size.grid002};
    margin-right: ${(props) => props.theme.size.grid002};
  }
`;

export const StyledLandingCarDetailsLeft = styled.div`
  margin-bottom: 55px;
  position: relative;
  z-index:0;
  @media (min-width: ${Breakpoints.b960}px) {
    width: 100%;
  }

  @media (min-width: ${Breakpoints.b1280}px) {
    width: 60%;
    margin-bottom: 0;
  }
`;

export const StyledLandingCarDetailsRight = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* Two columns */
  gap: 20px;

  @media (min-width: ${Breakpoints.b1280}px) {
    grid-template-columns: 1fr; /* One column */
    width: 35%;
    max-width: 420px;
    gap: 20px;
  }

  @media (min-width: ${Breakpoints.b560}px) and (max-width: ${Breakpoints.b1280}px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 17px;

    /* Order the elements */
    > *:first-child { buying
      grid-area: 1 / 1; /* First row, first column */
    }

    > *:nth-child(2) { map
      grid-area: ${props => !props.isEstimatyePayment ? '1 / 2' : '2 / 1'};
    }

    > *:nth-child(3) { prequalify
      grid-area: 1 / 2; /* First row, second column */
    }

    > *:nth-child(4) { payment
      grid-area: 2 / 2; /* Second row, second column */
    }
  }

  @media (max-width: ${Breakpoints.b560}px) {
    grid-template-columns: 1fr;
  }
`;

export const StyledLandingCarDetailsError = styled.div`
  margin-left: ${(props) => props.theme.size.grid002};
  margin-right: ${(props) => props.theme.size.grid002};
  justify-content: center;
`;

export const StyledDetailsStickyContainer = styled.div`
  position: relative;
  z-index: 1;
`;

export const StyledDetailsMainContainer = styled.div`
  width: 100%;
  overflow: hidden;
`;
